/**
 * SeriesNovelCard - 同系列小說卡片
 */

import { Link } from 'react-router-dom';
import type { SeriesNovelCardProps } from './types';
import { CoverImage } from '../CoverImage';

export function SeriesNovelCard({ novel, isCurrent }: SeriesNovelCardProps) {
  return (
    <Link
      to={`/novels/${novel.id}`}
      className={`flex-shrink-0 w-28 group ${isCurrent ? 'pointer-events-none' : ''}`}
    >
      <div className={`relative aspect-[3/4] rounded-card overflow-hidden mb-2 ${isCurrent ? 'ring-2 ring-primary-500' : ''}`}>
        <CoverImage
          src={novel.cover_url}
          alt={novel.title}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
          fallback={
            <div className="w-full h-full bg-neutral-100 dark:bg-neutral-800 flex items-center justify-center">
              <span className="text-2xl font-semibold text-neutral-400">
                {novel.title.charAt(0)}
              </span>
            </div>
          }
        />
        {isCurrent && (
          <div className="absolute inset-0 bg-primary-500/20 flex items-center justify-center">
            <span className="badge badge-primary text-xs">當前</span>
          </div>
        )}
        {/* 序號徽章 */}
        <div className="absolute bottom-2 left-2">
          <span className="badge badge-neutral text-xs backdrop-blur-sm bg-white/80 dark:bg-neutral-800/80">
            #{novel.series_order}
          </span>
        </div>
      </div>
      <p className={`text-sm truncate ${isCurrent ? 'text-primary-600 dark:text-primary-400 font-medium' : 'text-neutral-700 dark:text-neutral-300 group-hover:text-primary-600 dark:group-hover:text-primary-400'} transition-colors`}>
        {novel.title}
      </p>
    </Link>
  );
}
